import { LOGIN_SUCCESS, SET_HOTEL_ID } from "../actionTypes";

const initialState = {
  admin_id: null,
  auth_token: null,
  company_id: null,
  hotel_id: null,
  full_name: null,
  role_id: null,
  comp_hash: null,
};

const LoginReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case LOGIN_SUCCESS:
      return {
        ...state,
        admin_id: action.payload.admin_id,
        auth_token: action.payload.auth_token,
        company_id: action.payload.company_id,
        hotel_id: action.payload.hotel_id,
        full_name: action.payload.full_name,
        role_id: action.payload.role_id,
        comp_hash: action.payload.comp_hash,
      };
    case SET_HOTEL_ID:
      return {
        ...state,
        hotel_id: action.payload.hotel_id,
      };
    default:
      return state;
  }
};

export default LoginReducer;
